import { RadioGroup } from '@mui/material';
import type { VoidFunctionComponent } from 'react';
import { LabeledRadio } from '../../../generic/Forms';
import styles from './ProjectIssueTrackerSettings.module.less';

type Props = {
  useGlobalTrackerSettings: boolean;
  isDisabled: boolean;
  onUpdate: (settings: { useGlobalTrackerSettings: boolean }) => void;
};

//  This helps manage the updates, since RadioGroup will treat the value as a string.
enum GlobalTrackerSettingsOptions {
  Global = 'global',
  Project = 'project',
}

/**
 * ProjectIssueTrackerSettingsUseGlobalRadios
 */
const ProjectIssueTrackerSettingsUseGlobalRadios: VoidFunctionComponent<Props> = ({
  useGlobalTrackerSettings,
  isDisabled,
  onUpdate,
}) => {
  return (
    <RadioGroup
      className={styles.radios}
      value={useGlobalTrackerSettings
        ? GlobalTrackerSettingsOptions.Global
        : GlobalTrackerSettingsOptions.Project}
      //  This ensures that we are passing a boolean value back up
      onChange={(_event, val) => onUpdate({ useGlobalTrackerSettings: val === GlobalTrackerSettingsOptions.Global })}
      name="useGlobalTrackerSettings"
    >
      <div className={styles.radioOptions}>
        <LabeledRadio
          label="Use existing site settings"
          value={GlobalTrackerSettingsOptions.Global}
          isDisabled={isDisabled}
        />
        <LabeledRadio
          label="Use custom site settings"
          value={GlobalTrackerSettingsOptions.Project}
          isDisabled={isDisabled}
        />
      </div>
    </RadioGroup>
  );
};

export default ProjectIssueTrackerSettingsUseGlobalRadios;
